import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class ContactsValidation extends CustomCommonValidator implements ValidatorConstraintInterface {
	validate(dynamicProperties: any, validationArguments: ValidationArguments) {
		let properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
		let result: boolean = true;
		const validator = this.getValidator();
		this.message = '';
		if (properties.find(p => p == 'contacts') != null) {
			let contacts: ContactItem[] = dynamicProperties['contacts'] as ContactItem[];
			for (let i = 0; i < contacts.length; i++) {
				let contact = contacts[i];
				if (!validator.isNotEmpty(contact.displayName)) {
					result = false;
					this.message = this.message.concat(' Contact displayName is required <br />');
				}
				if (!validator.isNotEmpty(contact.postalCode)) {
					result = false;
					this.message = this.message.concat(' Contact postalCode is required <br />');
				}
				if (!validator.isDefined(contact.regionId)) {
					result = false;
					this.message = this.message.concat(' Contact regionId is required <br />');
				}
				if (!validator.isNotEmpty(contact.city)) {
					result = false;
					this.message = this.message.concat(' Contact city is required <br />');
				}
				if (!validator.isNotEmpty(contact.address)) {
					result = false;
					this.message = this.message.concat(' Contact city is required <br />');
				}
				if (contact.displayName != null && !validator.maxLength(contact.displayName, 256)) {
					result = false;
					this.message = this.message.concat(' Contact displayName is to long <br />');
				}
				if (contact.city != null && !validator.maxLength(contact.city, 128)) {
					result = false;
					this.message = this.message.concat(' Contact city is to long <br />');
				}
				if (contact.address != null && !validator.maxLength(contact.address, 512)) {
					result = false;
					this.message = this.message.concat(' Contact address is to long <br />');
				}
				if (contact.phones) {
					for (let phone of contact.phones) {
						if (phone.number != null && !validator.matches(phone.number, /\(?\d+\)?[-.\s]?\d+[-.\s]?\d+$/)) {
							result = false;
							this.message = this.message.concat(' MobilePhone is not a mobile phone <br />');
						}
					}
				}
				if (contact.emails) {
					for (let emails of contact.emails) {
						if (emails.email != null && !validator.isEmail(emails.email)) {
							result = false;
							this.message = this.message.concat('Email has bad format <br />');
						}
					}
				}
			}
		}

		return result;
	}

	defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
		return this.message;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/contactsValidator.ts